import { render, staticRenderFns } from "./PromotionSort.vue?vue&type=template&id=be1f7d62&scoped=true"
import script from "./PromotionSort.vue?vue&type=script&lang=js"
export * from "./PromotionSort.vue?vue&type=script&lang=js"
import style0 from "./PromotionSort.vue?vue&type=style&index=0&id=be1f7d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1f7d62",
  null
  
)

export default component.exports